import React from "react"
import News from "../../blocks/news"
import { graphql } from "gatsby"

export const pageQuery = graphql`
query {
  news: newsYaml(slug: { eq: "saveljevs_extended_contract" }) {
    ...NewsInfo
  }
}`

export default class NewsText extends News {
  renderNews() {
    return (
      <div className="row">
        <div className="col-xl-12">
          <p>Полузащитник сборной Латвии и клуба итальянской Серии А «Эллас Вернона» Алексейс Савельевс продлил соглашение с Catenaccio Sports Agency.</p>
        </div>
      </div>
    )
  }
}